import { render, staticRenderFns } from "./NavMenuInvitations.vue?vue&type=template&id=b004b0d0&scoped=true"
import script from "./NavMenuInvitations.vue?vue&type=script&lang=js"
export * from "./NavMenuInvitations.vue?vue&type=script&lang=js"
import style0 from "./NavMenuInvitations.vue?vue&type=style&index=0&id=b004b0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b004b0d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VList,VListItem,VTextField})
